// Cart-line adapter for the collect lead-time engine: facts come from the
// rendered line's already-derived props, lead times from site preferences —
// the same inputs the PDP adapter (useCollectScenario) reads from its store.
export const useCartCollectScenario = () => {
  const leadTimes = useCollectLeadTimes()

  // Store-line surface (bag/checkout change-store rows) resolves per store, so
  // it derives its own view (collectViewFromStoreLine) and enters here.
  const resolveLine = (view: CollectItemView, input: Omit<CartLineCollectInput, 'leadTimes'>): CartLineCollect =>
    resolveCartLineCollect(view, { ...input, leadTimes: leadTimes() })

  const resolveCartLine = (
    facts: {
      availableForClickAndCollect: boolean
      engravingText?: string
      isSpecialOrder: boolean
      isResized: boolean
    },
    input: Omit<CartLineCollectInput, 'leadTimes'>,
  ): CartLineCollect => resolveLine(collectViewFromCartLine(facts), input)

  return { resolveCartLine, resolveLine }
}
